import React from 'react';
import FormularioSenha from './components/FormularioSenha';
export default function RecuperarSenha(){return <FormularioSenha/>;}
